export default [
    {
        field: 'hr_employee',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Empleado',
        },
        //rules:['required','numeric']
    },
    {
        field: 'init_date',
        type: 'datePicker',
        vuetifyProps: {
            label: 'Fecha inicio relación laboral',
        },
    },
    {
        field: 'end_date',
        type: 'datePicker',
        value: '',
        vuetifyProps: {
            label: 'Fecha termino relación laboral',
        },
        rules:['required'],
    },
    {
        field: 'notice_date',
        type: 'datePicker',
        value: '',
        vuetifyProps: {
            label: 'Avisto de Despido',
        },
    },
    {
        field: 'payment_date',
        type: 'datePicker',
        value: '',
        vuetifyProps: {
            label: 'Fecha pago del finiquito',
        },
        rules:['required'],
    },
    {
        field: 'hr_causal_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Causal',
        },
        options: {
            data: [],
            text: 'causal',
            value: 'id',
        },
        rules:['required'],
    },
]